import { promiseRelationship } from 'chat/utils/ChatPromises';
import ChatActions from 'chat/actions/ChatActions';
import ChatMember from 'entities/ChatMember';
import ChatStore from 'chat/stores/ChatStore';
import Group from 'entities/Group';
import PotentialChatMember from 'entities/PotentialChatMember';
import Relationship from 'entities/Relationship';
import { rootGroup } from 'entities/RootGroup';
import Subscriber from 'entities/Subscriber';
import User from 'entities/User';

// basically an entity that has .id and .getName()\
// NOTE: The id MUST be the id of a User!
export type NamedInterlocutor = PotentialChatMember | Subscriber | User | ChatMember | number;

// TODO maybe make this a promise for the pathname and let the component do
// the router pusher so we're not passing the router around
export function pushRouterToChatWithMember(
  router: { push: Function },
  otherMember: NamedInterlocutor,
  group?: Group,
  catchHandler?: Function
): Promise<void> {
  return promiseRelationship(otherMember)
    .then((relationship) => {
      if (group) {
        routeWithSharedGroup(router, group, relationship);
        return;
      }
      goToChatForRelationship(relationship, router);
    })
    .catch((err) => {
      console.error(`ChatRouteHelper failed to load relationship - ${err}`);
      goToAllClasses(router);
      if (catchHandler) {
        catchHandler();
      }
    });
}

function goToChatForRelationship(relationship: Relationship, router: { push: Function }): void {
  const relatedUser = relationship.getRelatedUser();
  if (relatedUser && relatedUser.getUuid()) {
    ChatActions.queryChatStreamUUIDForUser(relatedUser.getUuid())
      .then((chatUUID) => {
        goToAllClasses(router, `${chatUUID}`);
      })
      .catch((_) => {
        goToAllClasses(router, `new/${relationship.id}`);
      });
  } else {
    goToAllClasses(router, `new/${relationship.id}`);
  }
}

function goToAllClasses(router: { push: Function }, endPath?: string) {
  router.push({ pathname: `/classes/${rootGroup.getCodeOrError()}/messages/${endPath || ''}` });
}

function routeWithSharedGroup(
  router: { push: Function },
  commonGroup: Group,
  relationship: Relationship
): void {
  const relatedUser = relationship.getRelatedUser();
  if (relatedUser && relatedUser.getUuid()) {
    ChatActions.queryChatStreamUUIDForUser(relatedUser.getUuid())
      .then((chatUUID) => {
        const pathname = `/classes/${commonGroup.getCodeOrError()}/messages/${chatUUID}`;
        router.push({ pathname });
      })
      .catch((_) => {
        const pathname = `/classes/${commonGroup.getCodeOrError()}/messages/new/${relationship.id}`;
        router.push({ pathname });
      });
  } else {
    const pathname = `/classes/${commonGroup.getCodeOrError()}/messages/new/${relationship.id}`;
    router.push({ pathname });
  }
}
